const CLOSED_CITIES = ["Pinhais", "São José dos Pinhais"];

// methods
const isCityClosed = city => {
  return CLOSED_CITIES.includes(city.display_name);
};

// filters
const name = address => {
  return address.name;
};

const streetAddress = address => {
  return `${address.street}, ${address.street_number} ${address.complement}`;
};

const residencyLocation = address => {
  const { district } = address;
  const { city } = address.district;
  const { state } = district.city;

  return `${address.zip_code}, ${district.display_name} - ${
    city.display_name
  }/${state.code}`;
};

const fullAddress = address => {
  return `${streetAddress(address)} ${residencyLocation(address)}`;
};

const districtId = address => {
  return address.district.id;
};

const districtName = address => {
  return address.district.display_name;
};

const cityName = address => {
  return address.district.city.display_name;
};

const stateCode = address => {
  return address.district.city.state.code;
};

export default {
  methods: {
    isCityClosed,
    districtId
  },

  filters: {
    name,
    streetAddress,
    residencyLocation,
    fullAddress,
    districtName,
    cityName,
    stateCode
  }
};



// WEBPACK FOOTER //
// ./src/mixins/addressMixin.js